<template>
  <!-- 初期設定画面 -->
  <div style="position: absolute; z-index: 30000; width: 100%; height: 100%; background: white; top: 1px;">
    <p style="margin-top: 24px;"><b style="font-size:28px; font-weight: 800;">カレンダー機能</b></p>
    <p style="width: 420px; margin: 0 auto; text-align: left;">
      カレンダー機能をお使いいただくためには下記の内、いずれかのカレンダーと連携が必要になります。
      お使いのカレンダーを下記の中からお選びください。
    </p>
    <br>
    <br>
    <div style="width: 320px; margin: 0 auto;">
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('googleAuthRedirect')"><img src="@/assets/btn_google_signin_light_normal_web_short.png" alt="Googleカレンダーと連携する" />Googleカレンダーと連携する</button>
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('changeModalCybozuOffice', true)">サイボウズオフィスと連携する</button>
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('changeModalGaroon', true)">ガルーンと連携する</button>
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('msofficeAuthRedirect')">Office 365と連携する</button>
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('changeModalGroupSession', true)">Group Sessionと連携する</button>
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('changeModalLineWorks', true)">LINE WORKSと連携する</button>
      <button class="button" style="width: 320px; margin-top: 12px;" @click="$emit('changeModalNoLinkage', true)">連携なしで利用する</button>
    </div>
    <img style="width: 256px; height: auto; position: absolute; bottom: 32px; right: 32px;" src="@/assets/template/Schedule-amico.png"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CalendarInit',
  componentName: 'CalendarInit',
  mounted () {
    // Googleカレンダー連携エラーまたはキャンセルメッセージ表示
    if (this.$route.query.error_google_calendar_auth || this.$route.query.cancel_google_calendar_auth) {
      if (this.$route.query.error_google_calendar_auth) {
        alert('Googleカレンダーとの連携でエラーが発生しました。')
      } else if (this.$route.query.cancel_google_calendar_auth) {
        alert('Googleカレンダーとの連携をキャンセルしました。')
      }
      // アラート表示のためのクエリパラメータを削除したURLにする
      this.$router.push(this.$route.path)
    }
  }
}
</script>

<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/CalendarInit.vue